module.exports = __webpack_public_path__ + "static/b-majhi-photo-aeb666f1aa3402f868887cd45dd92d30.jpg";